import { observable } from 'mobx'
import ResourcesStore from '../ResourcesStore'
import { ResourcesRequest } from '../ResourcesRequest'
class UploadMyFileStore {
  @observable isLoading = false

  create = async formData => {
    this.isLoading = true

    await ResourcesRequest.create(formData)

    this.isLoading = false

    ResourcesStore.search()
  }

  clearStore = () => {
    this.isLoading = false
  }
}

export default new UploadMyFileStore()
